import BadgesContainer from './Badges.container';
import Badges from './Badges';
export default BadgesContainer(Badges);
